/* EG Collections — Core helpers (normalize, handle/availability, DOM helpers, counters) */

function egNormalizeTagKey(s) {
  return String(s || "")
    .trim()
    .toLowerCase()
    .replace(/__/g, "_")
    .replace(/\s+/g, " ")
    .replace(/[^\w _-]/g, "");
}

function egGetLiteHandle(p) {
  if (!p) return "";
  const h =
    p.handle ??
    p.product_handle ??
    p.productHandle ??
    p.slug ??
    p.url_handle ??
    "";
  return String(h || "").trim();
}

function egGetLiteAvailable(p) {
  if (!p) return true; // unknown -> assume in stock

  const raw =
    p.variant_available ??
    p.variantAvailable ??
    p.available ??
    p.in_stock ??
    p.inStock ??
    p.available_for_sale ??
    p.availableForSale ??
    p.is_available ??
    p.isAvailable ??
    p.availability ??
    null;

  if (raw === true || raw === false) return raw;
  if (raw === 1 || raw === 0) return raw === 1;

  if (typeof raw === "string") {
    const v0 = raw.trim().toLowerCase();
    const v = v0.replace(/[\s-]+/g, "_");

    if (
      v === "true" || v === "1" || v === "yes" ||
      v === "in_stock" || v === "instock" ||
      v === "available" || v === "available_for_sale"
    ) return true;

    if (
      v === "false" || v === "0" || v === "no" ||
      v === "out_of_stock" || v === "outofstock" || v === "oos" ||
      v === "unavailable" || v === "sold_out"
    ) return false;
  }

  if (Array.isArray(p.variants) && p.variants.length) {
    let sawDefinitive = false;

    for (const v of p.variants) {
      const vr =
        v?.available ??
        v?.available_for_sale ??
        v?.availableForSale ??
        v?.in_stock ??
        v?.inStock ??
        null;

      if (vr === true || vr === 1) return true;
      if (vr === false || vr === 0) sawDefinitive = true;

      if (typeof vr === "string") {
        const s = vr.trim().toLowerCase().replace(/[\s-]+/g, "_");
        if (s === "true" || s === "1" || s === "in_stock" || s === "instock" || s === "available") return true;
        if (s === "false" || s === "0" || s === "out_of_stock" || s === "sold_out" || s === "unavailable") sawDefinitive = true;
      }

      const vq = v?.inventory_quantity ?? v?.inventoryQuantity ?? null;
      if (typeof vq === "number") {
        sawDefinitive = true;
        if (vq > 0) return true;
      }
      if (typeof vq === "string") {
        const n = parseInt(vq, 10);
        if (Number.isFinite(n)) {
          sawDefinitive = true;
          if (n > 0) return true;
        }
      }
    }

    return sawDefinitive ? false : true;
  }

  const tq =
    p.inventory_quantity ??
    p.inventoryQuantity ??
    p.totalInventory ??
    null;

  if (typeof tq === "number") return tq > 0;
  if (typeof tq === "string") {
    const n = parseInt(tq, 10);
    if (Number.isFinite(n)) return n > 0;
  }

  return true;
}

function egGetProductListEl(scope) {
  return (
    scope.querySelector(".product-list--collection") ||
    scope.querySelector(".product-list") ||
    null
  );
}

function egSetShowingText(el, from, to, total) {
  if (!el) return;

  const f = Math.max(0, parseInt(from || 0, 10));
  const t = Math.max(0, parseInt(to || 0, 10));
  const tot = Math.max(0, parseInt(total || 0, 10));

  const txt = (tot === 0)
    ? "Showing 0 products"
    : `Showing ${f}-${t} of ${tot} products`;

  el.textContent = txt;
}

function egUpdateClientSideResultCounters(from, to, total) {
  const showingCount = document.querySelector(".collection__showing-count");
  const resultsCount = document.querySelector(".collection__results, [data-collection-results]");
  const mobileResults = document.querySelector(".collection__mobile-active-filters-results");

  egSetShowingText(showingCount, from, to, total);
  egSetShowingText(resultsCount, from, to, total);
  egSetShowingText(mobileResults, from, to, total);

  // Mobile bottom-sheet "See products (xx)"
  var seeCount = document.querySelector("[data-eg-see-products-count]");
  if (seeCount) seeCount.textContent = String(Math.max(0, parseInt(total || 0, 10)));
}

function getCollectionBasePath() {
  const parts = window.location.pathname.split("/").filter(Boolean);
  const idx = parts.indexOf("collections");
  if (idx === -1 || !parts[idx + 1]) return window.location.pathname;
  return `/${parts[idx]}/${parts[idx + 1]}`;
}

function formatTagLabel(tag, startsWith) {
  if (!startsWith) return tag;
  if (tag.startsWith(startsWith)) return tag.slice(startsWith.length).trim();
  return tag;
}

function ensureTagGroupsContainer(root) {
  const scroll = root.querySelector(".eg-filterbar-scroll");
  return scroll || root;
}

// ================================
// Adverts (client-render injection)
// ================================

function egInjectAdvertsIntoList(listEl) {
  if (!listEl) return;

  var host = document.getElementById("eg-advert-templates");
  if (!host) return;

  // Clone template cards (already rendered by Liquid with correct grid_classes)
  var kids = host.children;
  if (!kids || !kids.length) return;

  // For safety: only inject once per render call.
  // (renderNow clears list, so this is mostly defensive)
  if (listEl.querySelector(".collection__item-guide")) return;

  // Slot positions match your Liquid pattern:
  // advert at eg_index 11 means "before product 11" -> before visible item index 10 (0-based)
  var slots = [11, 23, 35];

  // Collect current visible product tiles (client-render just created these)
  var tiles = listEl.querySelectorAll(".product-item");
  if (!tiles || !tiles.length) return;

  for (var i = 0; i < slots.length; i++) {
    var slot = slots[i];
    var insertBeforeIdx = slot - 1; // 11 -> index 10

    if (insertBeforeIdx < 0) continue;
    if (insertBeforeIdx >= tiles.length) continue;

    var templateNode = kids[i];
    if (!templateNode) continue;

    var clone = templateNode.cloneNode(true);

    // Insert before the product at that position
    var beforeNode = tiles[insertBeforeIdx];
    if (beforeNode && beforeNode.parentNode === listEl) {
      listEl.insertBefore(clone, beforeNode);
    }
  }
}

// ================================
// Smart Collection Header (dynamic)
// ================================

function egEnsureSmartHeaderEl() {
  // Prefer the brand header area (has h1)
  var host =
    document.querySelector(".collection__meta-inner") ||
    document.querySelector(".collections-header-content") ||
    document.querySelector(".collections-header") ||
    null;

  if (!host) return null;

  var el = host.querySelector(".eg-smart-collection-header");
  if (el) return el;

  el = document.createElement("p");
  el.className = "eg-smart-collection-header";

  // Insert after the main title if possible
  var h1 = host.querySelector(".collection__title");
  var h2 = host.querySelector("h2");
  var after = h1 || h2;

  if (after && after.parentNode === host && after.nextSibling) {
    host.insertBefore(el, after.nextSibling);
  } else {
    host.appendChild(el);
  }

  return el;
}

function egGetCollectionDisplayName() {
  var t =
    (document.querySelector(".collection__title") && document.querySelector(".collection__title").textContent) ||
    (document.querySelector(".collections-header-content h2") && document.querySelector(".collections-header-content h2").textContent) ||
    "";
  t = String(t || "").replace(/^\s+|\s+$/g, "");
  return t || "products";
}

function egPickFirstTagByPrefix(egSel, prefix) {
  if (!egSel || !egSel.forEach) return "";

  var hit = "";
  egSel.forEach(function (set) {
    if (hit) return;

    // set can be Set or Array depending on your implementation; support both
    if (set && typeof set.forEach === "function") {
      set.forEach(function (tag) {
        if (hit) return;
        tag = String(tag || "");
        if (tag.indexOf(prefix) === 0) hit = tag;
      });
    } else if (set && set.length) {
      for (var i = 0; i < set.length; i++) {
        var tag2 = String(set[i] || "");
        if (tag2.indexOf(prefix) === 0) { hit = tag2; break; }
      }
    }
  });

  return hit;
}

function egFormatTagValue(tag) {
  tag = String(tag || "");

  // "__" groups: "Firmness__Soft" => "Soft"
  var idx = tag.indexOf("__");
  if (idx !== -1) return tag.slice(idx + 2).replace(/^\s+|\s+$/g, "");

  // "_" groups: "Size_XL" => "XL"
  idx = tag.indexOf("_");
  if (idx !== -1) return tag.slice(idx + 1).replace(/^\s+|\s+$/g, "");

  return tag.replace(/^\s+|\s+$/g, "");
}

function egHeaderCfgForRoot(root) {
  var cfg = window.EG_COLLECTION_HEADER_CONFIG;
  if (!cfg || !cfg.defaults) return null;

  var handle = (root && root.dataset && root.dataset.egCollection) ? String(root.dataset.egCollection) : "";
  var col = (cfg.collections && handle && cfg.collections[handle]) ? cfg.collections[handle] : null;

  // Shallow merge (collection overrides defaults)
  var out = {};
  var d = cfg.defaults;

  out.defaultText = (col && col.defaultText) ? col.defaultText : d.defaultText;
  out.filteredText = (col && col.filteredText) ? col.filteredText : d.filteredText;
  out.context = (col && col.context) ? col.context : d.context;
  out.multiMode = (col && col.multiMode) ? col.multiMode : d.multiMode;

  out.orders = {};
  if (d.orders) for (var k in d.orders) out.orders[k] = d.orders[k];
  if (col && col.orders) for (var k2 in col.orders) out.orders[k2] = col.orders[k2];

  return out;
}

function egHeaderTokenReplace(tpl, map) {
  tpl = String(tpl || "");
  for (var k in map) {
    tpl = tpl.split("{" + k + "}").join(String(map[k] == null ? "" : map[k]));
  }
  return tpl;
}

function egHeaderExtractTagValues(egSel, prefix) {
  var vals = [];
  if (!egSel || !egSel.forEach) return vals;

  egSel.forEach(function (set) {
    if (!set) return;

    // Set-like
    if (typeof set.forEach === "function") {
      set.forEach(function (tag) {
        tag = String(tag || "");
        if (tag.indexOf(prefix) === 0) vals.push(tag);
      });
      return;
    }

    // Array-like
    if (set.length) {
      for (var i = 0; i < set.length; i++) {
        var t = String(set[i] || "");
        if (t.indexOf(prefix) === 0) vals.push(t);
      }
    }
  });

  // de-dupe
  var seen = {};
  var out = [];
  for (var j = 0; j < vals.length; j++) {
    var v = vals[j];
    if (seen[v]) continue;
    seen[v] = 1;
    out.push(v);
  }
  return out;
}

function egHeaderTagToValue(tag) {
  tag = String(tag || "");
  var idx = tag.indexOf("__");
  if (idx !== -1) return tag.slice(idx + 2).replace(/^\s+|\s+$/g, "");
  idx = tag.indexOf("_");
  if (idx !== -1) return tag.slice(idx + 1).replace(/^\s+|\s+$/g, "");
  return tag.replace(/^\s+|\s+$/g, "");
}

function egHeaderFormatMulti(values, mode, orderArr) {
  if (!values || !values.length) return "";

  // order if supplied
  if (orderArr && orderArr.length) {
    values.sort(function (a, b) {
      var ia = orderArr.indexOf(a);
      var ib = orderArr.indexOf(b);
      if (ia === -1) ia = 9999;
      if (ib === -1) ib = 9999;
      return ia - ib;
    });
  }

  if (values.length === 1) return values[0];

  if (mode === "range") {
    return values[0] + "–" + values[values.length - 1];
  }

  // default list
  return values.join(" / ");
}

function egUpdateSmartCollectionHeader(root, totalFiltered, totalAll) {
   var el = egEnsureSmartHeaderEl();
  if (!el) return;

  var cfg = egHeaderCfgForRoot(root);

  var totalA = parseInt(totalAll || 0, 10);
  if (!isFinite(totalA) || totalA < 0) totalA = 0;

  var totalF = parseInt(totalFiltered || 0, 10);
  if (!isFinite(totalF) || totalF < 0) totalF = 0;

  var name = egGetCollectionDisplayName();

  // detect “is filtered”
  var sp = new URLSearchParams(window.location.search || "");
  var isFiltered = false;

  sp.forEach(function (v, k) {
    if (isFiltered) return;
    if (k.indexOf("filter.") === 0) isFiltered = true;
    else if (k.indexOf("eg_tag_") === 0) isFiltered = true;
    else if (k.indexOf("eg_range_") === 0) isFiltered = true;
    else if (k === "eg_sort" && String(v || "") && String(v || "") !== "featured") isFiltered = true;
  });

  // if no config, keep your existing behaviour (fallback)
  if (!cfg) {
    el.textContent = isFiltered
      ? (totalF + " " + name + " · In stock first")
      : ("Compare " + totalA + " " + name + " — all sizes, surfaces, and firmness levels.");
    return;
  }

  if (!isFiltered) {
    el.textContent = egHeaderTokenReplace(cfg.defaultText, {
      countAll: totalA,
      count: totalF,
      name: name,
      bits: ""
    });
    return;
  }

  // build bits from config + EG selections
  var egSel = null;
  if (typeof egBuildEgTagSelectionsFromUrlAsFullTags === "function") {
    try { egSel = egBuildEgTagSelectionsFromUrlAsFullTags(); } catch (e) { egSel = null; }
  }

  var bits = [];
  var ctx = cfg.context || [];

  for (var i = 0; i < ctx.length; i++) {
    var item = ctx[i];
    if (!item || !item.type) continue;

    if (item.type === "literal") {
      if (item.text) bits.push(String(item.text));
      continue;
    }

    if (item.type === "tag_prefix") {
      var pref = String(item.prefix || "");
      if (!pref) continue;

      var tags = egHeaderExtractTagValues(egSel, pref);
      if (!tags.length) continue;

      var vals = [];
      for (var t = 0; t < tags.length; t++) vals.push(egHeaderTagToValue(tags[t]));

      var ord = cfg.orders && cfg.orders[pref] ? cfg.orders[pref] : null;
      var formatted = egHeaderFormatMulti(vals, cfg.multiMode || "list", ord);
      if (!formatted) continue;

      var lab = item.label ? (String(item.label) + " ") : "";
      bits.push(lab + formatted);
      continue;
    }
  }

  var bitsStr = bits.filter(Boolean).join(" · ");

  el.textContent = egHeaderTokenReplace(cfg.filteredText, {
    countAll: totalA,
    count: totalF,
    name: name,
    bits: bitsStr
  });
}
